/* eslint-disable id-length */
import { CONFIG } from "~/config";
import { ILocation, ILocationMeta } from "~/interfaces";

export interface IBrowserLocation {
	coords: {
		longitude: number;
		latitude: number;
		accuracy: number;
		altitudeAccuracy: number | null;
		heading: number | null;
		speed: number | null;
	};
	timestamp: number;
}

interface IGeoLocationResponse {
	location: ILocation;
	locationMeta: ILocationMeta;
}

interface IGetGeoLocation {
	mobile?: boolean;
	lang?: string;
}

function fetchData(url: string): Promise<IGeoLocationResponse | null> {
	return new Promise(resolve => {
		fetch(url).then(response => {
			response.json().then(json => {
				resolve(json);
			}, () => resolve(null));
		}, () => resolve(null));
	});
}

export async function getGeoLocation({
	mobile = undefined,
	lang = Userweb.defaultLang,
}: IGetGeoLocation) {
	// pro responzive
	const usp = new URLSearchParams();
	const mobileValue = mobile === undefined
		? window.innerWidth <= CONFIG.geoConfig.mobileMinWidth
		: mobile;

	usp.append("lang", lang);
	usp.append("mobile", (mobileValue ? 1 : 0).toString());
	// minuty - upravy
	usp.append("x", CONFIG.geoConfig.x.toString());
	usp.append("y", CONFIG.geoConfig.y.toString());

	const url = `/getLocation?${usp.toString()}`;
	const responseData = await fetchData(url);

	return responseData;
}

export function getBrowserLocation(timeout = 15000): Promise<IBrowserLocation> {
	return new Promise(resolve => {
		(window.geo || navigator.geolocation).getCurrentPosition((data: IBrowserLocation) => resolve(data), () => resolve(null), { timeout });
	});
}
